import { render, staticRenderFns } from "./fvMain.vue?vue&type=template&id=341476d1&lang=pug&"
var script = {}
import style0 from "./fvMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvMain.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvMain.vue
// module id = 82
// module chunks = 0 1